"use client"

import { Skeleton } from "@mui/material"
import styles from "@styles/PersonalAssistantMessage.module.css"
import clsx from "clsx"
import ReactMarkdown from "react-markdown"
import { usePersonalAssistantMessageContext } from "@/app/context/PersonalAssistantMessageContext"
import { useUserContext } from "@/app/context/UserContext"
import { useUserInfo } from "@/app/helpers/customHooks/useUserInfo"

export function PersonalAssistantMessage() {
  const personalAssistantMessageContext = usePersonalAssistantMessageContext()
  const {
    isConnectedToGmail,
    isConnectedToCalendar,
    isConnectedToSlack,
    loadingUserConnections,
  } = useUserContext()
  const { firstName } = useUserInfo() ?? {}

  const personalAssistantMessage =
    personalAssistantMessageContext?.personalAssistantMessage
  const loading =
    personalAssistantMessageContext?.loadingPersonalAssistantMessage
  const hasAnyConnections =
    isConnectedToGmail ||
    isConnectedToCalendar ||
    isConnectedToSlack ||
    loadingUserConnections

  return (
    <div className={styles.container}>
      <div className={styles.PAMContainer}>
        <div className={clsx("title2", styles.PAMText)}>
          {personalAssistantMessage &&
            splitPersonalAssistantMessageStringByRules(
              personalAssistantMessage.message || "",
            ).map((t, index) => (
              <ReactMarkdown
                key={index}
                components={{
                  a: ({ node, ...props }) => (
                    <a {...props} target="_blank" rel="noopener noreferrer" />
                  ),
                }}
              >
                {t}
              </ReactMarkdown>
            ))}
        </div>

        {!personalAssistantMessage && hasAnyConnections && (
          <div className={styles.skeleton}>
            <Skeleton variant="text" width={"90%"} height={29} />
            <Skeleton variant="text" height={29} />
            <Skeleton variant="text" width={"60%"} height={29} />
          </div>
        )}
        {!personalAssistantMessage && !hasAnyConnections && (
          <div className={styles.PAMText}>
            <ReactMarkdown>
              {`Welcome to Heather${firstName ? `, ${firstName}` : ""}!  \n\nIn order for me to help you guide you through the day, I require some access. Please connect your Gmail, Calendar, and
              Slack accounts in the [linked accounts view](/?view=linkedAccounts)
              to get started.`}
            </ReactMarkdown>
          </div>
        )}
      </div>
    </div>
  )
}

function splitPersonalAssistantMessageStringByRules(text: string): string[] {
  // First split by comma (keep comma with first part)
  const [firstPart, ...remainingParts] = text.split(/(?<=,)/)

  if (remainingParts.length === 0) {
    // No comma found, split by ". " only
    return text.split(/(?<=\. )/).filter((part) => part.trim().length > 0)
  }

  // Combine first part with comma and split remaining by ". "
  const result = [firstPart]
  const remainingText = remainingParts.join("")

  const dotParts = remainingText
    .split(/(?<=\. )/)
    .filter((part) => part.trim().length > 0)
  result.push(...dotParts)

  return result
}
